import dayjs from "dayjs";
import { Diamond, ExternalLink } from "lucide-react";

const SHEET_LINK = "https://docs.google.com/spreadsheets/d/1gLihEtIsO_5tZ8WGtkoyhBjGMz3STwrgjmlpZUXsF-8/edit?gid=1898267071";

export const Footer = ({ meta }) => (
  <footer data-testid="main-footer" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-14">
    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
      <div className="flex items-center gap-3">
        <span className="w-8 h-8 rounded-full bg-slate-900 flex items-center justify-center">
          <Diamond size={15} className="text-[#D4AF37]" />
        </span>
        <div>
          <p className="font-display text-base font-semibold tracking-tight">OPM Group / MIS</p>
          <p className="text-xs text-slate-400">
            {meta?.last_updated ? `Synced ${dayjs(meta.last_updated).format("DD MMM YYYY, HH:mm")} UTC` : "Live data"} · {meta?.date_from && meta?.date_to ? `${dayjs(meta.date_from).format("MMM YYYY")} – ${dayjs(meta.date_to).format("MMM YYYY")}` : ""}
          </p>
        </div>
      </div>
      <a
        href={SHEET_LINK}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="footer-sheet-link"
        className="inline-flex items-center gap-2 text-xs font-semibold text-slate-500 hover:text-[#B08D26] transition-colors"
      >
        Open source spreadsheet <ExternalLink size={13} />
      </a>
    </div>
  </footer>
);
